module.exports = __webpack_public_path__ + "img/appAsset-brand--nfe.d382613a.svg";